import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { AlertComponent } from '../common/alert/alert.component';
import { FilterFieldTypes } from '../common/common-constants';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { Globals } from '../models/globals.model';
import { Refinery } from '../models/refinery.model';
import { Tenant } from '../models/tenant.model';
import { adminService } from '../services/admin.service';
import { GlobalService } from '../services/global.service';
import { RefineryService } from '../services/refinery.service';
import { TenantPageComponent } from '../view-page/tenant-page/tenant-page.component';

@Component({
  selector: 'app-tenant',
  templateUrl: './tenant.component.html',
  styleUrls: ['./tenant.component.scss']
})
export class TenantComponent implements OnInit, OnDestroy {
  isLoading = false;
  tenantListDetails: any;
  selectedRefinery;
  selectedTenant: Tenant; 
  tenantKeyvaultUrl: any;
  tenantName: any;
  keyVaultName: any;
  tenantId: any;
  resourceGroup: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;
  searchText = '';

  displayedColumns: string[] = ['tenantName', 'tenantSecurityGrp','tenantId', 'lastModifiedBy', 'action'];
  destroyed = new Subject<any>();

  constructor(
    public _router: Router,
    public globals: Globals,
    public globalService: GlobalService,
    public httpClientObj: HttpClient,
    private readonly adminService: adminService,
    private readonly refinaryService: RefineryService,
    public dialog: MatDialog) {
      const emptyList: any[] = [];
    this.tenantListDetails = new MatTableDataSource(emptyList);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.fetchTenantData(this);
  }

  fetchTenantData(thisRef: TenantComponent) {
    if (thisRef.refinaryService.currentRefinery) {
      thisRef.selectedRefinery = thisRef.refinaryService.currentRefinery.refineryId;
      thisRef.getTenantList(thisRef, thisRef.selectedRefinery);
    }
    
    thisRef.refinaryService.refinerySelected.subscribe((data: Refinery) => {
      thisRef.selectedRefinery = data.refineryId;
      thisRef.getTenantList(thisRef, thisRef.selectedRefinery);
    });
  }

  getTenantList(thisRef: TenantComponent, id) {
    thisRef.isLoading = true;
    thisRef.selectedFilters = [];
    thisRef.filterList=[];
    thisRef.adminService.getTenantList(id).subscribe((data: any): void => {
      if(data && data.length > 0){
        thisRef.tenantListDetails = new MatTableDataSource(data);
        thisRef.tenantListDetails.filterPredicate=(data,filter:string): boolean=>{
          return data.tenantName.toLowerCase().includes(filter)||data.tenantSecurityGrp.toLowerCase().includes(filter)||data.tenantId.toString().includes(filter)||data.lastModifiedBy.toLowerCase().includes(filter);
        }
        thisRef.masterData = [...data];
        if (thisRef.filterList.length === 0) {
          thisRef.createFilterList();
        }
        thisRef.tenantListDetails.sort = thisRef.sort;
        thisRef.tenantListDetails.paginator = thisRef.paginator;
        if (thisRef.globalService.isNotNull(thisRef.searchText)) {
          thisRef.globalService.applyFilter(thisRef.searchText, thisRef.tenantListDetails);
        }      
        thisRef.isLoading = false;
      }
      else{
        thisRef.tenantListDetails.data = [];
        thisRef.isLoading = false;
      }
    }, (error: Error) => {
      console.log('Error while fetching tenant list', error.message);
       thisRef.isLoading = false;
    });
  }

  openDialog(mode, element: Tenant) {
    const dataToPass = { displayType: mode, data: element };
    this.globalService.openModelWindow(this.fetchTenantData, this, TenantPageComponent, '40%', 'custom-modalbox', dataToPass);
    return true;
  }

  deleteModel(thisRef: any) {
    this.keyVaultName = thisRef.tenantKeyvaultUrl.split("https://")[1].split(".vault.azure.net")[0];
    this.tenantId = thisRef.tenantId;
    let tenantname = thisRef.tenantName;
    this.adminService.GetResourceGroup(this.keyVaultName).subscribe((data: any): void => {
      this.resourceGroup = data.ResourceGroup;
      localStorage.setItem("delKV", "true");
      const dataToPass = {
        title: 'Delete',
        isDelete: true,
        message: 'You are deleting the tenant [' + tenantname + ']  <br/> Delete its key vault [' + this.keyVaultName + '] as well from resource group [' + data.ResourceGroup + '] :'
      };
      this.selectedTenant = thisRef;
     this.globalService.openModelWindow(this.deleteModelAfterConfirmation, this, ConfirmModelComponent, '640px', 'confirm-modalbox', dataToPass);
     
    }, (error: Error) => {
      console.log('Error while fetching master component list', error.message);
    });


     }

  openComponent(element) {
    const queryParams = {
      searchText: element.tenantName
    };
    this._router.navigate(['/component', queryParams]);
  }

  openDataSource(element) {
    const queryParams = {
      searchText: element.tenantName
    };
    this._router.navigate(['/datasource', queryParams]);
  }

  setSearchText(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.searchText = filterValue;
  }

  /**
   * Displays confirmation after deletion
   * @param thisRef
   */
  deleteModelAfterConfirmation(thisRef: TenantComponent) {
    thisRef.adminService.deleteTenant(thisRef.tenantId, thisRef.keyVaultName, thisRef.resourceGroup, localStorage.getItem("delKV")).subscribe(data => {
      if (data) {
        let message = 'Tenant [' + thisRef.selectedTenant.tenantName + ']  deleted successfully!';
        if (localStorage.getItem("delKV") == "true") {
          message = 'Tenant [' + thisRef.selectedTenant.tenantName + '] and key vault [' + thisRef.keyVaultName +'] deleted successfully!';
        }
       // Tenant < TenantName > and key vault < KeyVaultName > deleted successfully!
        thisRef.globalService.showAlert(AlertComponent, { success: true, message: message });
        thisRef.getTenantList(thisRef, thisRef.selectedRefinery);
        thisRef.isLoading = false;
      } else {
        thisRef.deleteFailed(thisRef);
      }
    }, error => {
      thisRef.deleteFailed(thisRef);
    });

  }

  deleteFailed(thisRef: TenantComponent) {
    thisRef.globalService.showAlert(AlertComponent, { success: false, message: 'Tenant ' + thisRef.selectedTenant.tenantName + ' could not be deleted!' });
    thisRef.getTenantList(thisRef, thisRef.selectedRefinery);
    thisRef.isLoading = false;

  }

  createTenant() {
    const dataToPass = { displayType: 'add', data: {} };
    this.globalService.openModelWindow(this.fetchTenantData, this, TenantPageComponent, '40%', 'custom-modalbox', dataToPass);
    return true;
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    const filterRes: FilterResponseModel = event.filterResponse;
    this.tenantListDetails.data = this.globalService.conditionalDataFiltering(filterRes, this.tenantListDetails.data);
    this.selectedFilters.push(filterRes);
    if (this.popover.isOpen()) {
      this.popover.close();
    }
  }

  /**Creates data for filter list */
  createFilterList() {
    for (let a = 0; a < this.displayedColumns.length - 1; a++) {
      const tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldType = FilterFieldTypes.text;
      tempFilter.fieldName = this.globalService.replaceDisplayText(this.displayedColumns[a]);
      if (this.displayedColumns[a] === 'tenantName') {
        unique = Array.from(new Set(this.tenantListDetails.data.map(a => a.tenantName)));
      } else if (this.displayedColumns[a] === 'tenantSecurityGrp') {
        unique = Array.from(new Set(this.tenantListDetails.data.map(a => a.tenantSecurityGrp)));
      } else if (this.displayedColumns[a] === 'tenantId') {
        tempFilter.fieldType = FilterFieldTypes.values;
        unique = Array.from(new Set(this.tenantListDetails.data.map(a => a.tenantId)));
      } else if (this.displayedColumns[a] === 'lastModifiedBy') {
        unique = Array.from(new Set(this.tenantListDetails.data.map(a => a.lastModifiedBy)));
      }
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const i = this.selectedFilters.indexOf(selectedFilter);
    if (i >= 0) {
      this.selectedFilters.splice(i, 1);
      this.tenantListDetails.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (const ele of this.selectedFilters) {
          this.tenantListDetails.data = this.globalService.conditionalDataFiltering(ele, this.tenantListDetails.data);
        }
      }
    }
  }

  ngOnDestroy(): void {
    localStorage.removeItem("delKV");
    this.destroyed.next(true);
    this.destroyed.complete();
  }

}
